<template>
  <div>
    <v-menu class="main-menu__employee-btn" offset-y left fixed>
      <v-btn
        class="overflow--hidden main-menu__button ml-0 mb-3"
        :large="!miniDrawer"
        :fab="miniDrawer"
        slot="activator"
        round
        depressed
        block
        @click="handleIsCompanySelected"
      >
        <img v-if="miniDrawer" src="@/assets/icons/ico_phone-call.svg" alt="">
        <span v-if="!miniDrawer">{{$t('Components.MainMenu.newEmployee')}}</span>
        <v-icon v-if="!miniDrawer">keyboard_arrow_down</v-icon>
      </v-btn>

      <v-list v-if="this.company" class="dropdown-menu-actions__list">
        <v-list-tile
          v-if="$route.name !== 'Employee' && hasRole('employee', 'ROLE_POST_EMPLOYEE')"
          :to="{ name: 'Employee', params: { type: 'cadastrar' } }"
        >
          {{ $t('Views.EmployeesPage.addEmployee') }}
        </v-list-tile>

        <v-list-tile
          v-if="hasRole('company', 'ROLE_POST_COMPANY_ID_EMPLOYEE_UPLOAD')"
          :to="{ name: 'EmployeeBulkOperation' }"
        >
          {{ $t('Views.EmployeesPage.addCollaboratorsBulk') }}
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { hasRole } from 'utils/functions'

export default {
  name: 'NewEmployeeDropdown',
  props: {
    miniDrawer: {
      type: Boolean
    }
  },
  computed: {
    ...mapState({
      company: ({ company }) => company.selectedCompany
    })
  },
  methods: {
    ...mapActions({
      infoAlert: 'snackbarAlert/info'
    }),

    hasRole (group, role) {
      return hasRole(group, role)
    },

    handleIsCompanySelected () {
      !this.company && this.infoAlert(this.$t('Common.selectCompany'))
    }
  }
}
</script>

<style lang="scss" scoped>
.main-menu__employee-btn {
  min-width: 56px;
  width: 100%;
}

.main-menu__button {
  background-color: $primary;
  background-image: linear-gradient(103deg, $primary, $accent-2);
  box-shadow: 0 2px 5px 0 rgba($gray-8, 0.35);
  color: $gray-8;
}

.main-menu__button-icon {
  width: 24px;
}
</style>
